import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Marketplace } from '../components/Marketplace';
import { AIProducts } from '../components/AIProducts';
import { Stats } from '../components/Stats';
import { Investors } from '../components/Investors';
import { Team } from '../components/Team';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="bg-[#FAFAF8] min-h-screen" data-id="element-631">
      <Nav data-id="element-632" />
      <Hero data-id="element-633" />
      <TrustBar data-id="element-634" />
      <Marketplace data-id="element-635" />
      <AIProducts data-id="element-636" />
      <Stats data-id="element-637" />
      <Investors data-id="element-638" />
      <Team data-id="element-639" />
      <CTA data-id="element-640" />
      <Footer data-id="element-641" />
    </div>;
}